// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3W0nw","inputWrap":"CustomTip_inputWrap__3OjAW"};